export enum View {
  Timeline = 'timeline',
  List = 'list',
  Cards = 'cards',
  Map = 'map',
  Roster = 'roster'
}

export enum ViewContext {
  Own = 'myActivityPlanning',
  Team = 'activityPlanning'
}
